<template>
  <el-dialog
    :visible.sync="visibleProxy"
    title="Lịch sử thêm số lượng"
    width="720px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="ps-dialog"
  >
    <div v-if="schoolRow" class="ps-history-header">
      <div>
        <span class="ps-history-header__eyebrow">Lịch sử thêm số lượng</span>
        <h3>{{ schoolRow.school.name }}</h3>
        <p>{{ schoolRow.package ? schoolRow.package.code : 'Chưa gán gói' }} · {{ histories.length }} lần thêm</p>
      </div>
      <div class="ps-history-total">
        <span>Tổng số lượng đã thêm</span>
        <strong>+{{ schoolRow.addonTotal | formatNumber }}</strong>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="histories"
      border
      class="sk-table ps-table ps-history-table"
      size="small"
      empty-text="Chưa có lịch sử thêm số lượng"
    >
      <el-table-column label="Thời điểm" width="150">
        <template slot-scope="{ row }">{{ row.createdAt | formatDateTime }}</template>
      </el-table-column>
      <el-table-column label="Số lượng thêm" width="130" align="center">
        <template slot-scope="{ row }">
          <span class="ps-addon-amount">+{{ row.amount | formatNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Lý do thêm số lượng" prop="note" min-width="220" show-overflow-tooltip />
      <el-table-column label="Người thực hiện" prop="createdBy" width="170" align="center" show-overflow-tooltip />
    </el-table>

    <span slot="footer" class="ps-dialog-footer">
      <el-button type="primary" @click="visibleProxy = false">Đóng</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "AddonHistoryDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    schoolRow: {
      type: Object,
      default: null,
    },
    histories: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
};
</script>
